import SectionHeading from "./SectionHeading";
import { impressions } from "@/mocks/movieContent";

const tagStyles = [
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
];

export default function ImpressionSection() {
  return (
    <section id="impressions" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="观后感"
          title="观后感：大家看完之后，都在讨论什么"
          description="下面整理的是观众在看完影片后最常出现的几类感受与讨论角度。它们代表的是一种普遍反应，而非某个人的具体评价。"
          icon="ri-emotion-line"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {impressions.map((item, index) => (
            <article
              key={item.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/50 p-5 md:p-6"
            >
              <span
                className={`self-start px-2.5 py-1 rounded-full text-xs font-label font-medium whitespace-nowrap ${
                  tagStyles[index % tagStyles.length]
                }`}
              >
                {item.tag}
              </span>
              <h3 className="mt-3.5 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed flex-1">{item.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-secondary-50 p-5 md:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50">
            <i className="ri-shield-check-line text-xl"></i>
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">
            观后感是很个人的东西。同一部影片，有人看到遗憾，有人看到边界，有人只是被氛围留住。本文呈现的是常见角度，
            真正的感受，还是建议你自己看完后慢慢体会。
          </p>
        </div>
      </div>
    </section>
  );
}